import { clone } from 'ramda';

import { setOfferType } from '@/packages/JsonQuery/setOfferType';
import { FOfferType, type TJsonQuery } from '@/packages/JsonQuery/types';

export function switchToResidential(jsonQuery: TJsonQuery) {
  return (): TJsonQuery => {
    let nextJsonQuery = clone(jsonQuery);
    nextJsonQuery = setOfferType(nextJsonQuery)(FOfferType.Flat);

    return nextJsonQuery;
  };
}
